import { authHeader } from "../../../auth";
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default {
    data() {
        return {
            editor: ClassicEditor,
            editorConfig: {      
                ckfinder: {
                    uploadUrl: this.$serverURL + this.$api.editor.uploadFileURL
                }
            },
            setURL: this.$serverURL + this.$api.category.singleCategoryAPI,
            id: this.$route.params.id,
            previewIcon: "",
            singlecategory: {},
        }

    },
    async mounted() {
        await this.getcategoryData();
    },
    methods: {
        uploadcategoryIcon: function (event) {
            this.singlecategory.icon = event.target.files[0];
            let input = this.$refs.icon;
            let file = input.files;
            if (file && file[0]) {
                let reader = new FileReader
                reader.onload = e => {
                    this.previewIcon = e.target.result
                }
                reader.readAsDataURL(file[0])
            }
        },
        validate() {
            if (!this.singlecategory.title) {
                this.$swal.fire({
                    icon: "error",
                    text: "Add category title."
                })
                return false;
            } 
            if (!this.singlecategory.description) {
                this.$swal.fire({
                    icon: "error",
                    text: "Add category description."
                })
                return false;
            }
            if (!this.singlecategory.icon) {
                this.$swal.fire({
                    icon: "error",
                    text: "Add category icon."
                })
                return false;
            }
            return true;
        },
        getcategoryData: async function () {
            let config = {
                method: "GET",
                url: this.setURL + this.id,
                headers: {
                    "Authorization": authHeader()
                }
            }
            await this.$axios(config).then(async (response) => {
                if (response.status == 200) {
                    this.singlecategory = await response.data.data;
                }
                else {
                    this.$swal.fire({
                        icon: "error",
                        text: "Failed! please try again."
                    });
                }
            }).catch(error => {
                this.$swal.fire({
                    icon: "error",
                    text: "Failed! please try again." + error
                });
            });
        },
        updatecategory: async function () {
            if (this.validate()) {
                try {
                    let formData = new FormData();
                    formData.append('title', this.singlecategory.title);
                    formData.append('description', this.singlecategory.description);
                    formData.append('icon', this.singlecategory.icon);
                    let config = {
                        method: 'PATCH',
                        url: this.setURL + this.singlecategory._id,
                        data: formData,
                        headers: {
                            "Authorization": authHeader(),
                            "Content-Type": "multipart/form-data",
                        }
                    };
                    await this.updateDataToBackend(config);
                    this.$router.push("/category");
                } catch (error) {
                    this.$swal.fire({
                        icon: "error",
                        text: "Something went wrong. Please try again! " + error
                    });
                }
            }

        }
    },
}